/**
 * Route for `pdf-csv-invoice-export`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PdfCsvInvoiceExportPage } from "../features/pdf-csv-invoice-export/PdfCsvInvoiceExportPage";

export const pdfCsvInvoiceExportRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/pdf-csv-invoice-export",
	component: PdfCsvInvoiceExportPage,
});

export default pdfCsvInvoiceExportRoute;
